module.exports = __webpack_public_path__ + "media/18_Long.a5cb944c.mp3";